import React from 'react';
import { Flex, Image, Text } from '@zillow/constellation';
import DataCard from 'app/shared/components/DataCard';
import { Temperature } from 'app/shared/types/Temperature';

import Cool from 'images/marketTemperature/cool.svg';
import Warm from 'images/marketTemperature/warm.svg';
import Hot from 'images/marketTemperature/hot.svg';

interface MarketTemperatureProps {
  temp: Temperature;
  isSmallScreen: boolean;
}

const MarketTemperature: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<MarketTemperatureProps>>
> = (props) => {
  const { temp, isSmallScreen } = props;
  return temp === Temperature.unknown ? null : (
    <DataCard
      heading="Market Temperature"
      copyText="Market temperature is based on changes in renter demand compared to the national average. For example, a hot market has increasing demand."
      useFullScreen={isSmallScreen}
    >
      <Flex display="flex" flexDirection="column" alignItems="center" marginY="md">
        {temp === Temperature.cool && <Image src={Cool} alt="cool" height={218} width={229} />}
        {temp === Temperature.warm && <Image src={Warm} alt="warm" height={218} width={229} />}
        {temp === Temperature.hot && <Image src={Hot} alt="hot" height={218} width={229} />}
        <Text as="p" fontColor="textMedium" fontType="bodySmall" marginTop="lg">
          Temperature is based on all bedrooms and all property types.
        </Text>
      </Flex>
    </DataCard>
  );
};

export default MarketTemperature;
